import React from "react";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
import { GroupedRichTextBladeSchema } from "../../../schemas/blades/GroupedRichText";
import { hasVisibleContent } from "../../../functional/showBladeHeader";
import { BladeContent } from "../../../components/BladeContent";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { MediaImage, MediaType } from "../../../components/Media";
import { BladeHeader } from "./BladeHeader";
import { RichText } from "../../../components/RichText";
import { Accordion, AccordionItem, AccordionHeader, AccordionContent, AccordionTrigger, } from "../../../components/Accordion";
import { z } from "zod";
export const LandingRichTextAccordionContractSchema = GroupedRichTextBladeSchema.extend({
    type: z.literal("landingRichTextAccordion"),
});
const _LandingRichTextAccordion = ({ backdrop, header, groups, className, ...bladeProps }) => {
    const headerContent = hasVisibleContent(header);
    return (React.createElement(Blade, { className: className, "data-testid": "landingRichTextAccordion", ...bladeProps },
        backdrop && (React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, backdrop.background?.type === MediaType.IMAGE && (React.createElement(MediaImage, { "data-testid": "backdrop-background-image", media: backdrop.background, role: "presentation" }))),
            React.createElement(BackdropForeground, null, backdrop.foreground?.type === MediaType.IMAGE && (React.createElement(MediaImage, { "data-testid": "backdrop-foreground-image", media: backdrop.foreground, role: "presentation" }))))),
        React.createElement(BladeContent, { width: "large" },
            headerContent && React.createElement(BladeHeader, { ...header }),
            React.createElement("div", { className: "body" },
                React.createElement(Accordion, { type: "multiple" }, groups.map((group, index) => (React.createElement(AccordionItem, { value: `item-${index}`, key: index },
                    React.createElement(AccordionHeader, null,
                        React.createElement(AccordionTrigger, null, group.label)),
                    React.createElement(AccordionContent, null, !!group?.content && React.createElement(RichText, { ...group?.content }))))))))));
};
export const LandingRichTextAccordion = styled(_LandingRichTextAccordion) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=LandingRichTextAccordion.js.map